import { render, staticRenderFns } from "./WebMenu.vue?vue&type=template&id=386106fa&"
import script from "./WebMenu.vue?vue&type=script&lang=js&"
export * from "./WebMenu.vue?vue&type=script&lang=js&"
import style0 from "./WebMenu.vue?vue&type=style&index=0&id=386106fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports